// Generated by Claude Code
import { PartDetailPanel } from '#components/domain/operations/parts/detail/part-detail-panel.tsx'
import { PartEditDrawer } from '#components/domain/operations/parts/edit/part-edit-drawer.tsx'
import { PermissionGuard } from '#components/tools/permission-guard.tsx'
import { PermissionService } from '#core/entities/auth/roles/Permission.ts'
import { readAnyGroups } from '#core/entities/auth/roles/permission-gate-helpers.ts'
import type Part from '#core/entities/operations/parts/Part.ts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_app/$companyId/parts/$partId')({
  component: RouteComponent,
  staticData: {
    title: 'Part Detail',
  },
})

function RouteComponent() {
  return (
    <PermissionGuard permissions={readAnyGroups(PermissionService.PARTS)} redirectOnNotAuthorized>
      <PartDetailPageContent />
    </PermissionGuard>
  )
}

function PartDetailPageContent() {
  const { companyId, partId } = Route.useParams()
  const navigate = useNavigate()
  const { t } = useTranslation('parts')

  const [editPart, setEditPart] = useState<Part | null>(null)
  const [reloadKey, setReloadKey] = useState(0)

  function handleBack() {
    void navigate({ to: '/$companyId/parts', params: { companyId } })
  }

  return (
    <div className="container-fluid d-flex flex-column h-100 py-3">
      <div className="row justify-content-center flex-grow-1">
        <div className="col-12 col-lg-10 col-xl-8 d-flex flex-column">
          <div className="mb-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1"
              onClick={handleBack}
            >
              <ArrowLeft size={14} />
              {t('shared.actions.backToList')}
            </button>
          </div>
          <div className="flex-grow-1 overflow-hidden card rounded-3 p-0">
            <PartDetailPanel
              partId={partId}
              onClose={handleBack}
              onEdit={setEditPart}
              reloadKey={reloadKey}
            />
          </div>
        </div>
      </div>

      <PartEditDrawer
        isOpen={editPart !== null}
        mode="edit"
        part={editPart ?? undefined}
        onClose={() => setEditPart(null)}
        onSaved={() => { setEditPart(null); setReloadKey((k) => k + 1) }}
      />
    </div>
  )
}
